import { render, staticRenderFns } from "./ErfolgComponent.vue?vue&type=template&id=1379be94&scoped=true&"
import script from "./ErfolgComponent.vue?vue&type=script&lang=ts&"
export * from "./ErfolgComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ErfolgComponent.vue?vue&type=style&index=0&id=1379be94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379be94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VTooltip})
